import { createSelector } from 'reselect'
import { selectBase } from './selectBase'

export const selectCancelsAt = createSelector(
  selectBase,
  base => base.cancels_at
)
